import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, IconButton } from '@mui/material'
import { withStyles } from '@mui/styles'
import SearchIcon from '@mui/icons-material/Search'

import { tableActionsStyles } from './table-actions.style'

export const TableActions = withStyles(tableActionsStyles)((props) => {
  if (!props.rowData) {
    return null
  }

  const navigate = useNavigate()
  const appId = props.rowData['id']

  const handleGoToDetail = (e) => {
    e.stopPropagation()
    navigate(`/applications/${appId}`)
  }

  const appButtons = {
    detail: {
      onClick: handleGoToDetail,
      icon: <SearchIcon />,
    },
  }
  const availableActions = ['detail']

  return (
    <Box className={props.classes.actionRow} p={0}>
      {availableActions.map((action) => {
        return (
          <IconButton
            className={props.classes.actionButton}
            key={action}
            size="small"
            onClick={appButtons[action].onClick}
          >
            {appButtons[action].icon}
          </IconButton>
        )
      })}
    </Box>
  )
})
